import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FlexSpacer } from 'ui/flexSpacer';
import { PageHeader } from 'ui/pageHeader';
import { Container } from 'ui/container';
import { selectIsSMSLinkShorteningFeatureFlagOn } from 'core/userContext/selectors';
import { BREADCRUMB } from '../constants';
import { fetchMailDomainsRequest, fetchDeepLinksRequest } from '../actions';
import {
  selectSendingDomainsWithEspDetails,
  selectTrackingDomainsWithDeepLinksAndLinkShorteningTemplateIds,
  getVerificationErrors,
} from '../selectors';

import { SendingDomainsTable } from './SendingDomainsTable';
import { TrackingDomainsTable } from './TrackingDomainsTable';
import { VerificationErrors } from './VerificationErrors';

export const TEXT = {
  header: 'Custom mail domains',
  trackingDomainsVerificationErrors: 'Tracking domain verification errors',
};

// the future state, but currently hidden behind a feature flag
export const MEDIUM_AGNOSTIC_TEXT = {
  ...TEXT,
  header: 'Custom domains',
};

export const MailDomains = () => {
  const dispatch = useDispatch();
  const sendingDomains = useSelector(selectSendingDomainsWithEspDetails);
  const trackingDomains = useSelector(
    selectTrackingDomainsWithDeepLinksAndLinkShorteningTemplateIds,
  );
  const verificationErrors = useSelector(getVerificationErrors);
  const isLinkShorteningFeatureFlagOn = useSelector(selectIsSMSLinkShorteningFeatureFlagOn);

  const CONTENT = isLinkShorteningFeatureFlagOn ? MEDIUM_AGNOSTIC_TEXT : TEXT;

  useEffect(() => {
    dispatch(fetchMailDomainsRequest());
  }, [dispatch]);

  const projectHasTrackingDomains = trackingDomains.length !== 0;

  useEffect(() => {
    dispatch(fetchDeepLinksRequest());
  }, [dispatch]);

  return (
    <FlexSpacer flexDirection="column" alignItems="stretch" gap="cardGap">
      <PageHeader breadcrumb={BREADCRUMB(isLinkShorteningFeatureFlagOn)}>
        {CONTENT.header}
      </PageHeader>
      <Container>
        {verificationErrors?.length > 0 && (
          <VerificationErrors verificationErrors={verificationErrors} />
        )}
        <TrackingDomainsTable trackingDomains={trackingDomains} />
      </Container>
      <Container>
        <SendingDomainsTable
          sendingDomains={sendingDomains}
          projectHasTrackingDomains={projectHasTrackingDomains}
        />
      </Container>
    </FlexSpacer>
  );
};
